export default __webpack_public_path__ + "static/media/blur_email.748cc92a.png";